const AdminStats = ({ stats, setActiveTab, setFocusedStatus }) => (
  <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
    <button type="button" onClick={() => { setActiveTab("orders"); setFocusedStatus("pending"); }} className="bg-[#18181B] border border-white/10 p-4 text-left hover:border-[#CCFF00]/40 transition-colors">
      <p className="text-3xl font-black text-[#CCFF00]">{stats.pending}</p>
      <p className="text-xs text-zinc-500 uppercase">Validées</p>
    </button>
    <button type="button" onClick={() => { setActiveTab("orders"); setFocusedStatus("in_progress"); }} className="bg-[#18181B] border border-white/10 p-4 text-left hover:border-blue-500/40 transition-colors">
      <p className="text-3xl font-black text-blue-400">{stats.progress}</p>
      <p className="text-xs text-zinc-500 uppercase">En cours</p>
    </button>
    <button type="button" onClick={() => { setActiveTab("orders"); setFocusedStatus("delivered"); }} className="bg-[#18181B] border border-white/10 p-4 text-left hover:border-green-500/40 transition-colors">
      <p className="text-3xl font-black text-green-400">{stats.delivered}</p>
      <p className="text-xs text-zinc-500 uppercase">Livrées</p>
    </button>
    <div className="rounded-3xl bg-[#18181B] border border-white/10 p-5">
      <p className="text-3xl font-black text-red-400">{stats.urgent}</p>
      <p className="text-xs text-zinc-500 uppercase">Urgentes</p>
    </div>
  </div>
);

export default AdminStats;
